import React from 'react';

class Table extends React.Component {
  render() {
    return (
      <div>
        <h1 className="page-title">Table</h1>
      </div>
    );
  }
}

export default Table;



/** WEBPACK FOOTER **
 ** ./src/components/Table.js
 **/